import { HistoricalCompensationData } from '@modules/EvaluationModule/interfaces/CompensationData';

export const getPreviousCompenstation = (
  arr: HistoricalCompensationData[],
  target: HistoricalCompensationData
): HistoricalCompensationData | null => {
  const index = arr.findIndex((compensation) => compensation.period === target.period);
  return arr[index + 1];
};
